module.exports = __webpack_public_path__ + "media/images/top/sp-slide-prev-45692a0e5b6f14c9b1fc8e7e6a601c15.svg";